export const NAVIGATION_DESKTOP_ANIMATION_WAIT_TIME = 500;

export const NAVIGATION_NAME_MAX_COUNT = 28;

export const NAVIGATION__PRODUCT_NAME_MAX_COUNT = 40;
